import { SignIn } from "@clerk/clerk-react";
import { Navigate, useLocation } from "react-router-dom";
import { useUser } from "@clerk/clerk-react";

import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";

export default function LoginPage() {
  const { isSignedIn } = useUser();
  const location = useLocation();

  // Redirect if already authenticated
  if (isSignedIn) {
    const from = (location.state as any)?.from?.pathname || "/dashboard";
    return <Navigate to={from} replace />;
  }

  return (
    <Card className="w-full max-w-md mx-auto">
      <CardHeader className="text-center">
        <CardTitle className="text-2xl font-bold">Welcome Back</CardTitle>
        <CardDescription>Sign in to your PredictiveMX account</CardDescription>
      </CardHeader>
      <CardContent>
        <SignIn
          routing="path"
          path="/login"
          signUpUrl="/sign-up"
          fallbackRedirectUrl="/dashboard"
          appearance={{
            elements: {
              // Root container
              rootBox: "mx-auto",
              card: "shadow-none border border-gray-200 rounded-lg bg-white",
              
              // Header
              headerTitle: "text-2xl font-bold text-gray-900 font-sans",
              headerSubtitle: "text-gray-600 font-sans",
              
              // Form elements
              formButtonPrimary: 
                "bg-trust-blue hover:bg-trust-blue-700 text-white font-medium rounded-lg transition-all shadow-sm hover:shadow-md hover:-translate-y-px focus-visible:ring-2 focus-visible:ring-trust-blue focus-visible:ring-offset-2",
              formFieldInput: 
                "border-gray-200 focus:border-trust-blue focus:ring-2 focus:ring-trust-blue focus:ring-offset-2 rounded-md font-sans",
              formFieldLabel: 
                "text-gray-700 font-medium font-sans",
              formFieldInputShowPasswordButton:
                "text-gray-500 hover:text-gray-700",
              
              // Social buttons
              socialButtonsBlockButton: 
                "border-gray-200 hover:bg-gray-50 rounded-lg font-sans transition-all focus-visible:ring-2 focus-visible:ring-trust-blue focus-visible:ring-offset-2",
              socialButtonsBlockButtonText: 
                "font-medium",
              
              // Links
              footerActionLink: 
                "text-trust-blue hover:text-trust-blue-700 font-medium transition-colors",
              identityPreviewEditButton:
                "text-trust-blue hover:text-trust-blue-700",
              formResendCodeLink:
                "text-trust-blue hover:text-trust-blue-700 font-medium",
              
              // Divider
              dividerLine: "bg-gray-200",
              dividerText: "text-gray-500 font-sans",
              
              // Footer
              footer: "font-sans",
              footerAction: "font-sans",
              footerActionText: "text-gray-600 font-sans",
              
              // Alert/Error messages
              alertText: "font-sans",
              formFieldErrorText: "text-critical-red font-sans",
              
              // Other elements
              otpCodeFieldInput: 
                "border-gray-200 focus:border-trust-blue focus:ring-2 focus:ring-trust-blue rounded-md font-sans",
              formButtonReset: 
                "text-gray-600 hover:text-gray-900 font-medium font-sans",
            },
            variables: {
              colorPrimary: "#2563EB",
              colorText: "#1F2937",
              colorTextSecondary: "#6B7280",
              colorInputText: "#1F2937",
              colorInputBackground: "#FFFFFF",
              colorBorder: "#E5E7EB",
              colorDanger: "#DC2626",
              borderRadius: "0.5rem",
              fontFamily: "Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
              fontSize: "1rem",
            },
          }}
        />
      </CardContent>
    </Card>
  );
}
